<template lang='pug'>
td.text--center.color--black60.show--bigScreens
  .tableTop10-info2
    h4.tableTop10-subscriber {{ follower }}
    .tableTop10-graph.show--bigScreens
      .tableTop10-graphItemWrapper
        .tableTop10-graphItem(v-for="b in bar")

</template>
<script>
export default {
  props: {
    bar: Number,  //Which represents the percentage of progress bar.
    follower: String
  }
}
</script>
